import React, { useState } from 'react';
import Box from '@mui/material/Box';
import BulkPullsheetsForm from './BulkPullsheetsForm'
import orderHelpers from '../../helpers/orders';
import acumaticaHelpers from '../../helpers/acumatica';
import {jsPDF} from "jspdf";
import 'jspdf-autotable';
import bulkHelpers from '../../helpers/bulk';

function BulkPullsheets(props) {

    const company = props.company;
    const token = props.token;

    const [acumaticaOrderNum, setAcumaticaOrderNum] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');


    const handleChange = (event) => {
        let func = `set${event.target.name[0].toUpperCase() + event.target.name.substring(1)}`
        eval(func)(event.target.value)
    }


    const handleDateChange = (date, field) => {
        (field === 'endDate' ? setEndDate : setStartDate)(date);
    };


    const formatAcuOrderNum = (acuOrderNum) => {
        while (acuOrderNum.length < 7) {
            acuOrderNum = '0' + acuOrderNum;
        }
        return acuOrderNum;
    }

    const formatOrders = async(orders) => {
        let pos = {};
        for(let order of orders) {
            let po = order.internal_po_number;
            if(!(po in pos)) {
                pos[po] = {
                    acu_order_num: order.acu_order_num,
                    address1: order.address1,
                    address2: order.address2,
                    city: order.city,
                    external_po_number: order.external_po_number,
                    internal_po_number: po,
                    name: order.name,
                    order_date: order.order_date,
                    order_status: order.order_status,
                    state: order.state,
                    upload_date: order.upload_date,
                    vendor_status: order.vendor_status,
                    vendor_name: order.vendor_name,
                    zip_code: order.zip_code,
                    foam: order.foam,
                    bolster: order.bolster,
                    shipments: {},
                    items: []
                }
            }
            let tn = order.pro_number;
            if(!(order.pro_number in pos[po].shipments)) {
                pos[po].shipments[tn] = {
                    acu_ship_num: order.acu_ship_num,
                    acumatica_status: order.acumatica_status,
                    carrier: order.carrier,
                    method: order.method,
                    date: order.upload_date,
                    truck_number: order.truck_number,
                    pro_number: tn,
                    shipment_status: order.shipment_status,
                    tote_number: order.tote_number,
                    vendor_status: order.vendor_status,
                    warehouse: order.warehouse,
                    total_on_shipment: 0,
                    pullsheet_id: order.pullsheet_id,
                    items: {}
                }
            }
            let sku = order.internal_sku;
            if(!(sku in pos[po].shipments[tn].items)) {
                pos[po].shipments[tn].items[sku] = {
                    external_sku: order.external_sku,
                    root_sku: order.root_sku,
                    internal_price: order.internal_price,
                    external_price: order.external_price,
                    size: order.size,
                    pa_location: order.pa_location,
                    internal_sku: sku,
                    box: order.default_box,
                    root_sku_quantity: '',
                    foam: order.foam,
                    bolster: order.bolster,
                    quantity: 0
                }
            }
            pos[po].items.push({order_id: order.order_id, root_sku: order.root_sku, root_sku_quantity: '', internal_sku: sku, description: order.description, size: order.size, box: order.default_box, quantity: order.quantity, pa_location: order.pa_location, foam: order.foam, bolster: order.bolster})
            pos[po].shipments[tn].items[sku].quantity += order.quantity;
            pos[po].shipments[tn].total_on_shipment += order.quantity
        }
        let out = [];
        let id = 1;
        for(let po in pos) {
            let shipments = [];
            for(let tn in pos[po].shipments) {
                let items = [];
                for(let sku in pos[po].shipments[tn].items) {
                    items.push(pos[po].shipments[tn].items[sku]);
                }
                pos[po].shipments[tn].items = items;
                shipments.push(pos[po].shipments[tn]);
            }
            pos[po].shipments = shipments;
            pos[po].id = id;
            out.push(pos[po]);
            id++;
        }
        return out;
    }

    const formatAcumaticaOrder = (orders) => {
        let pos = {};
        for(let order of orders) {
            let po = order.CustomerOrderNbr.value || order.OrderNbr.value;

            if(!(po in pos)) {
                pos[po] = {
                    acu_order_num: order.OrderNbr.value,
                    internal_po_number: po,
                    order_date: order.Date.value,
                    vendor_name: order.CustomerName.value,
                    shipments: {},
                    items: []
                }
            }
            let sku = order.InventoryID.value;
            if(!(sku in pos[po].items)) {
                pos[po].items.push({
                    internal_price: order.UnitPrice.value,
                    internal_sku: sku,
                    root_sku: order.RootSku.value,
                    size: order.Size.value,
                    description: order.Description_3.value,
                    pa_location: order.Warehouse.value === '02' ? order.PAPullLocation.value : order.MCAPullLocation.value,
                    quantity: order.Quantity.value,
                    root_sku_quantity: order.RootSKUQTY.value,
                    box: order.AmazonDirectBox.value
                });
            }
        }
        let out = [];
        let id = 1;
        for (let po in pos) {
            pos[po].id = id;
            out.push(pos[po]);
            id++;
        }
        return out;
    }

    const sortOrder = async(order) => {
        const items = order.items;
        const formattedItems = {};
        let total_quantity = 0;
        for (let item of items) {
            if (!(item.internal_sku in formattedItems)) {
                formattedItems[item.internal_sku] = {
                    root_sku: item.root_sku,
                    root_sku_quantity: item.root_sku_quantity,
                    internal_sku: item.internal_sku, 
                    description: item.description, 
                    size: item.size,
                    box: item.box, 
                    quantity: 0, 
                    pull_location: item.pa_location,
                    component: item.component,
                    bolster: item.bolster,
                    foam: item.foam
                }
            } 
            formattedItems[item.internal_sku].quantity += item.quantity;
            total_quantity += item.quantity;
        }
        const sortedItems = Object.values(formattedItems).sort((a, b) => {
            if (!a.pull_location && b.pull_location) return 1;
            if (a.pull_location && !b.pull_location) return -1;
            if (!a.pull_location && !b.pull_location) return 0;
        
            if (a.pull_location < b.pull_location) return -1;
            if (a.pull_location > b.pull_location) return 1;
        
            return 0;
        });
        let pdfItems = [];
        for(let sku in sortedItems) {
            let item = sortedItems[sku];
            pdfItems.push([item?.root_sku, item?.root_sku_quantity, item?.internal_sku, item?.description, item?.size, item?.box, item.quantity, item?.pull_location, item?.component, item?.bolster, item?.foam]);
        }
        return {pdfItems: pdfItems, total_quantity: total_quantity}
    }

    const getOrder = async() => {
        let params = {
            acu_order_num: acumaticaOrderNum !== '' ? formatAcuOrderNum(acumaticaOrderNum) : null,
            order_valid: true
        }
        try {
            const res = await orderHelpers.getBulkOrders(props.company + "_bulk", params, props.token);
            const formatted_order = await formatOrders(res);
            return formatted_order;
        } catch(err) {
            console.log(err);
        }
    }

    const getAcumaticaOrder = async() => {
        try {
            const acu_order = await acumaticaHelpers.getAcumaticaOrderDetail(formatAcuOrderNum(acumaticaOrderNum), company, token);
            const formatted_order = formatAcumaticaOrder(acu_order);
            return formatted_order;
        } catch(err) {
            console.log(err);
        }
    }

    const getAcumaticaOrdersByDate = async() => {
        try {
            const startStr = startDate?.format('YYYY-MM-DD') ?? null;
            const endStr   = endDate?.format('YYYY-MM-DD') ?? null;

            console.log(startStr);
            console.log(endStr);
            const acu_order = await acumaticaHelpers.getAcumaticaOrderDetailByDate(startStr, endStr, company, token);
            const formatted_order = formatAcumaticaOrder(acu_order);
            return formatted_order;
        } catch(err) {
            console.log(err);
        }
    }

    const checkDownloadedBefore = async () => {
        let params = {
            acu_order_num: acumaticaOrderNum !== '' ? formatAcuOrderNum(acumaticaOrderNum) : null,   
        };
        try {
            const res = await bulkHelpers.getBulkPullsheetDownloadInfo(props.company + "_bulk", params, props.token);
            return res;
        } catch(err) {
            console.log(err);
        };
    };

    const insertDownloadInfo = async () => {
        let params = {
            acu_order_num: acumaticaOrderNum !== '' ? formatAcuOrderNum(acumaticaOrderNum) : null,   
        };
        try {
            const res = await bulkHelpers.insertBulkPullsheetDownloadInfo(props.company + "_bulk", params, props.token);
            return res;
        } catch(err) {
            console.log(err);
        };
    }

    const createBulkPullsheet = async() => {
        props.setLoading(true);
        try {
            if (acumaticaOrderNum === '') {
                return props.toast.error("Enter an order number!")
            } else {
                const downloadInfo = await checkDownloadedBefore();
                if (downloadInfo.length) {
                    var localDate = new Date(downloadInfo[0].date);
                    if(!window.confirm(`Acumatica Order Number ${acumaticaOrderNum} was last downloaded \n${localDate}.\n\nDo you want to download again?`)) {
                        setAcumaticaOrderNum('');
                        return;
                    };
                };
                const res = await getOrder();
                let order = res[0];
                let sorted_order;
                let order_from_acumatica = false;
                if (order) {
                    sorted_order = await sortOrder(order);
                } else {
                    const res = await getAcumaticaOrder();
                    if (res.length) {
                        order = res[0];
                        sorted_order = await sortOrder(order);
                        order_from_acumatica = true;
                    } else {
                        return props.toast.error("Could not find order number!");
                    };
                }; 
                await insertDownloadInfo();
                const JsBarcode = require ('jsbarcode');
                let barcode = document.createElement("img");
                JsBarcode(barcode, order.acu_order_num);
                const sorted_items = sorted_order.pdfItems;
                const total_quantity = sorted_order.total_quantity;
                let items_array = await orderHelpers.getSkuAndDescription(props.company, props.token);
                if(order_from_acumatica){
                    order = await addBolstersAndFoamToAcumaticaOrder(order, items_array.data);
                }
                await createPdf(order.acu_order_num, barcode, order.internal_po_number, order.vendor_name, sorted_items, total_quantity, items_array.data, order.items);
            }
        } catch(err) {
            console.log(err);
        } finally {
            props.setLoading(false);
        }
    }

    const createBulkPullsheetFromDate = async() => {
        props.setLoading(true);
        try {
            let sorted_order;
            let orders = {};
            let sorted_items;
            let total_quantity;
            let items_array;
            const res = await getAcumaticaOrdersByDate();
            if (res.length) {
                orders.acu_order_nums = await combineAcuOrderNumbers(res);
                orders.items = await combineByInventoryID(res);
                items_array = await orderHelpers.getSkuAndDescription(props.company, props.token);
                orders = await addBolstersAndFoamToAcumaticaOrder(orders, items_array.data);
                sorted_order = await sortOrder(orders);
                sorted_items = sorted_order.pdfItems;
                total_quantity = sorted_order.total_quantity;
            } else {
                return props.toast.error("Could not find any orders!");
            };

            await createPdf(orders.acu_order_nums, null, "1", 'TX', sorted_items, total_quantity, items_array.data, orders);
        }
        catch(err) {
            console.log(err);
        } finally {
            props.setLoading(false);
        }
    }

    const combineByInventoryID = async(orders) => {
        const map = new Map();
      
        for (const order of orders || []) {
          for (const item of order.items || []) {
            const sku = item.internal_sku;
            if (!sku) continue;
      
            let acc = map.get(sku);
            if (!acc) {
              acc = {
                internal_sku: sku,
                description: item.description || null,
                size: item.size || null,
                box: item.box || null,
                root_sku: item.root_sku || null,
                root_sku_quantity: item.root_sku_quantity || null,
                component: item.component,
                pa_location: item.pa_location || null,
                quantity: 0
              };
              map.set(sku, acc);
            }

            const qty = item.quantity || 0;
            acc.quantity += qty;
      
            // Keep first non-null values for details
            if (acc.description == null) acc.description = item.description;
            if (acc.size == null) acc.size = item.size;
            if (acc.box == null) acc.box = item.box;
            if (acc.root_sku == null) acc.root_sku = item.root_sku;
            if (acc.pa_location == null) acc.pa_location = item.pa_location;
          }
        }
      
        return Array.from(map.values());
    }

    const combineAcuOrderNumbers = async(orders) =>{
        const orderNums = orders.map(order => order.acu_order_num);
        return orderNums
    }


    const createPdf= async(acu_order_num, barcode, internal_po_number, customer, items, total, items_array, order_items) => {
        try{
            let doc = new jsPDF();
            let fill_array =  []


            if(customer === 'TX'){
                let combined_skus_bolsters = await combineOrderAndBolsters(items, items_array, fill_array.bolster);
                combined_skus_bolsters = await addBoxTotals(combined_skus_bolsters);
                console.log("combined_sku", combined_skus_bolsters);
                fill_array.fill = await createFillArray(combined_skus_bolsters.fill, items_array, true);
                fill_array.nofill = await createFillArray(combined_skus_bolsters.nofill, items_array, true);


                await makePullsheetPDF(doc, acu_order_num, barcode, internal_po_number, customer, combined_skus_bolsters.fill, combined_skus_bolsters.fill.length);
                await makePullsheetPDF(doc, acu_order_num, barcode, internal_po_number, customer, combined_skus_bolsters.nofill, combined_skus_bolsters.nofill.length, "nofill");
                await makePullsheetPDF(doc, acu_order_num, barcode, internal_po_number, customer, fill_array.fill.foam, fill_array.fill.foam.length, "foam");
                await makePullsheetPDF(doc, acu_order_num, barcode, internal_po_number, customer, fill_array.nofill.foam, fill_array.nofill.foam.length, "foam");

            }
            else{
                fill_array = await createFillArray(order_items, items_array);
                await makePullsheetPDF(doc, acu_order_num, barcode, internal_po_number, customer, items, total);
                await makePullsheetPDF(doc, acu_order_num, barcode, internal_po_number, customer, fill_array.foam, fill_array.foam_length, "foam");
                await makePullsheetPDF(doc, acu_order_num, barcode, internal_po_number, customer, fill_array.bolster, fill_array.bolster_length, "bolster");
            }


            const pdfBlob = doc.output("blob");
            const pdfUrl = URL.createObjectURL(pdfBlob);

            const printWindow = window.open(pdfUrl);
            if (printWindow) {
                printWindow.onload = () => {
                    printWindow.focus();
                    printWindow.print();
                };
            }
        } catch(err) {
            console.log(err);
        } finally {
            props.setLoading(false);
        }
    }

    const combineOrderAndBolsters = async(orders, sku_info, bolster_array)=> {

        let split_orders = {};
        split_orders.fill = [];
        split_orders.nofill = [];

        let sku_bolster_map = {};
        for (let obj of sku_info) {
            sku_bolster_map[obj.sku] = obj.bolster;
        }

        let fill_sku_desc_map = {};
        if(bolster_array){
            for (let obj of bolster_array) {
                fill_sku_desc_map[obj.sku] = obj.description;
            }
        }

        for (let i = 0; i < orders.length; i++) {
            let order = orders[i];
            let sku = order[2];
            if (sku_bolster_map[sku]) {
                let new_row = []
                new_row[2] = sku_bolster_map[sku];
                new_row[6] = order[6];

                if (fill_sku_desc_map[sku]) {
                    new_row[3] = fill_sku_desc_map[sku];
                }

                split_orders.fill.push(orders[i]);
                split_orders.fill.push(new_row);
                i++;
            }
            else{
                split_orders.nofill.push(orders[i])
            }

        }
        return split_orders
    }

    const addBoxTotals = async(orders) => {
        let orders_with_boxes = {fill: [], nofill: []};
        if(orders.fill){
            const fillBoxMap = await makeBoxMap(orders.fill);
            const fillBoxRows = await convertMapsToOrderArray(fillBoxMap);
            orders_with_boxes.fill = orders.fill.concat(fillBoxRows);
        }
        if(orders.nofill){
            const noFillBoxMap = await makeBoxMap(orders.nofill);
            const nofillBoxRows = await convertMapsToOrderArray(noFillBoxMap);
            orders_with_boxes.nofill = orders.nofill.concat(nofillBoxRows);
        }
        return orders_with_boxes;
    }

    const makeBoxMap = async(orders) => {
        const byBox = new Map();
        for(const row of orders){
            const box_type = row[5];
            const qty = Number(row[6]);
            if(box_type){
                let newQty = 0;
                if(byBox.get(box_type)) newQty = byBox.get(box_type) + qty;
                else newQty = qty;
                byBox.set(box_type, newQty);
            } 
        }
        return byBox
    } 
    
    const convertMapsToOrderArray = async(boxMap) => {
        const boxArray = Array.from(boxMap);
        const boxRows =  boxArray.map(([box, total]) => {
            const row = Array(11).fill(null);
            row[0] = "Box Totals"
            row[2] = box;
            row[6] = Number(total) || 0;
            return row;
        });
        return boxRows;
    }
    

    const createFillArray = async(pullsheet_data, items_array, texas_pullsheet=false) => {
        let fill_arrays = {};
        let foam_array = await processItemType("foam", pullsheet_data, texas_pullsheet);

        foam_array = await addDescription(foam_array, items_array);
        foam_array = await sortFillArray(foam_array);
        let foam_array_length = await findLength(foam_array);
        let bolster_array = [];
        let bolster_array_length = 0;
        if(texas_pullsheet === false){
            for (let i = 0; i < foam_array.length; i++) {
                let item = foam_array[i];
                if (item[0].includes("FIBER")) {
                    bolster_array.push(item);
                    foam_array.splice(i, 1);
                    i--;
                }
            }
            bolster_array = await processItemType("bolster", pullsheet_data);
            bolster_array = await addDescription(bolster_array, items_array);
            bolster_array = await sortFillArray(bolster_array);
            bolster_array_length = await findLength(bolster_array);
            return {"foam": foam_array, "bolster": bolster_array, "foam_length": foam_array_length, "bolster_length": bolster_array_length};
        }
        else{
            return {"foam": foam_array,"foam_length": foam_array_length};
        }
    }


    const findLength = async(item_array) => {
        let total = 0;
        for(let item of item_array){
            total += item[1] //quantity is the second item in this array
        }
        return total;
    }

    const sortFillArray = async(fill_array) => {
        try{
            let small = [];
            let medium = [];
            let large = [];
            let jumboXL = [];
            let jumboPlus = [];
            let missing = [];
            for(let i = 0; i < fill_array.length; i++){
                let item = fill_array[i];
                if(item.length < 3) missing.push(item);
                else if(item[2].includes("Small")) small.push(item);
                else if(item[2].includes("Medium")) medium.push(item);
                else if(item[2].includes("Large")) large.push(item);
                else if(item[2].includes("Jumbo Plus") || item[2].includes("JM PLUS")) jumboPlus.push(item);
                else if(item[2].includes("Jumbo") || item[2].includes("XL")) jumboXL.push(item);
                else missing.push(item);
            }
            let full_array = [].concat(small, medium, large, jumboXL, jumboPlus, missing);
            return full_array;
        }
        catch(err){
            console.log(err);
        }
    }

    const addBolstersAndFoamToAcumaticaOrder = async(orders, items_array) => {
        orders.items.forEach(order => {
            const matching_item = items_array.find(items_item => items_item.sku === order.internal_sku);
            if(matching_item) {
                order.foam = matching_item.foam;
                order.bolster = matching_item.bolster;
            }
        });
        return orders;
    }

    const makePullsheetPDF = async(doc, acu_order_num, barcode, internal_po_number, customer, items, total, fill="None") => {

        if(items.length === 0){
            return;
        }
        if(fill != "None"){
            doc.addPage();
        }
        doc.setFontSize(10);
        let now = new Date();
        let date = now.toISOString().slice(0,10)
        doc.text(180, 15, date);

        if(barcode) doc.addImage(barcode.src, 150, 20);

        if(customer === 'TX'){
            const label_x = 10;
            const value_x = 25;
            doc.text(label_x, 5, "Acumatica Order #:");

            if (Array.isArray(acu_order_num)) {
                const chunkSize = 8;
                let y = 15;
                for (let i = 0; i < acu_order_num.length; i += chunkSize) {
                    const chunk = acu_order_num.slice(i, i + chunkSize);
                    const lineText = chunk.join("   ");
                    doc.text(value_x, y, lineText);
                    y += 5; 
                }
            } 
            else {
                doc.text(value_x, 15, acu_order_num);
            }
        }
        else{
            const label_x = 10;
            const value_x = 50;
            doc.text(label_x, 15, "Acumatica Order #:");
            doc.text(value_x, 15, acu_order_num);
            doc.text(label_x, 20, "PO #:");
            doc.text(value_x, 20, internal_po_number);
            doc.text(label_x, 25, "Customer:");
            doc.text(value_x, 25, customer);
        }

        doc.setFontSize(16);
        doc.text(15, 60, "Total Pieces: " + String(total));
        let sku_header = [["Root SKU", "Root SKU Qty", "SKU", "Description", "Size", "Box", "Qty", "Pull Location"]];
        if(fill === "foam" || fill === "bolster"){
            let Capfill = fill.charAt(0).toUpperCase() + fill.slice(1);
            sku_header = [[Capfill,  "Quantity", "Description"]];
        }
        doc.autoTable({
            head: sku_header,
            body: items,
            theme: "striped",
            columnStyles: {
                3: {cellWidth: 'auto'}
            },
            startY: 62,
            margin: {top: 15, bottom: 15, left: 15, right: 15},
            headStyles: {
                fillColor: "#187947",
                textColor: "white",
                halign: "center",
                valign: "middle"
            },
            didParseCell: function (data) {
                data.cell.styles.fontSize = 8.5;
            }
        });
    };

    const addDescription = async(pullsheet_data, items_array) => {
        try{
            pullsheet_data.forEach(pullsheet_item => {
                const matching_item = items_array.find(items_item => items_item.sku === pullsheet_item[0]);
                
                if(matching_item) {
                    pullsheet_item.push(matching_item.description);
                }
            });
            return pullsheet_data;
        }     
        catch(err) {
            console.log(err);
        } finally {
            props.setLoading(false);
        }
    
    }
    
    const processItemType = async(itemType, pullsheet_data, texas_pullsheet=false) => {
        try{
            let items = [];
            let split_array = await splitFill(pullsheet_data, itemType, texas_pullsheet);
            let quantities = split_array.reduce((prev, curr) => {
                let key = curr[itemType];
                if (!(key in prev) && key) {
                    prev[key] = { quantity: 0 };
                }
                prev[key].quantity += curr?.quantity;
                return prev;
            }, {});
        
            for (let key in quantities) {
                let item = quantities[key];
                item[itemType] = key;
                items.push([item?.[itemType], item?.quantity]);
            }
            return items;
        }
        catch(err) {
            console.log(err);
        } finally {
            props.setLoading(false);
        }
    }


    const splitFill = async (pullsheet_data, itemType, texas_pullsheet) => {
        let split_array = [];
        if(texas_pullsheet){
            for (let data of pullsheet_data) {
                if (data[10]) {
                    let string_to_split = data[10].split("/");
                    for (const part of string_to_split) {
                        split_array.push({ "foam": part, "quantity": data[6] });
                    }
                }
            }
        }
        else{
            for (let data of pullsheet_data) {
                if (data[itemType]) {
                    let string_to_split = data[itemType].split("/");
                    for (const part of string_to_split) {
                        split_array.push({ [itemType]: part, "quantity": data.quantity });
                    }
                }
            }
        }
        return split_array;
    }

    return(
        <Box className = {props.isMobile ? "mobile-top" : "desktop-top"} sx = {{display: 'flex', flexDirection: 'column'}}>
            <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} sx = {{paddingLeft: 2}}>
                <h1>Bulk Pull Sheet</h1>
                <BulkPullsheetsForm
                    isMobile = {props.isMobile}
                    acumaticaOrderNum = {acumaticaOrderNum}
                    handleChange = {handleChange}
                    handleDateChange = {handleDateChange}
                    startDate = {startDate}
                    endDate = {endDate}
                    createBulkPullsheet = {createBulkPullsheet}
                    createBulkPullsheetFromDate = {createBulkPullsheetFromDate}

                />
            </Box>
        </Box>
    )
}

export default BulkPullsheets;